/* eslint-disable no-unused-vars */
import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { AddAttachmentFileType } from '../store/base.action';
import * as _ from 'lodash';
import { EnvironmentService } from './environment.service';


export enum AttachmentFileType {
  DES_DECISION_KEY = '/des/decisionkey'
}
@Injectable({
  providedIn: 'root'
})
export class AttachDocumentsService {
  private newlyAttachedFiles: any = {};
  private formDataKey: any = 'files';

  constructor(private http: HttpClient,
    public store: Store,
    private env: EnvironmentService) { }

  getFileTypes(fileType: AttachmentFileType, decisionKey: string, requestBody: any) {
    let fileTypeUrl = '';
    switch (fileType) {
      case AttachmentFileType.DES_DECISION_KEY:
        fileTypeUrl = this.env.getEnvironment().baseUrl + this.env.getEnvironment().wso2amEndPoint + '/des' + this.env.getEnvironment().wso2amApiVersion + '/api/v1/decisions/decisionDefinitionkey/' + decisionKey + '/evaluate';
        break;
    }

    return new Promise((resolve, reject) => {
      const storedFileTypes = this.store.selectSnapshot(state => {
        return state.baseShared.attachmentsFileType;
      });
      const fileTypeKey = this.getAttachmentsFileTypeKey(fileTypeUrl, requestBody);
      if (storedFileTypes === null || _.isEmpty(storedFileTypes[fileTypeKey])) {
        this.http.post(fileTypeUrl, requestBody).subscribe((res: any) => {
          const data = res.resultList;
          this.store.dispatch(new AddAttachmentFileType(fileTypeKey, data));
          resolve(data);
        });
      } else {
        resolve(storedFileTypes[fileTypeKey]);
      }
    });
  }

  private getAttachmentsFileTypeKey(url: string, requestBody: string) {

    let key = url;
    key += JSON.stringify(requestBody).replace(' ', '-');
    return key;
  }
  downloadAttachment(url: Record<string, unknown>, downloadEndpoint: any, id?:any) {
    //https://dev-kenya.cargoes.com/dms/api/v1/attachments/requestId/download change url as per communicated with aniket.
    const envValue: any = this.env.getEnvironment();
    //envValue.baseUrl + envValue.wso2amEndPoint + downloadEndpoint + envValue.wso2amApiVersion + url
    let newurl = `${envValue.baseUrl}${envValue.wso2amEndPoint}${downloadEndpoint}${envValue.wso2amApiVersion}/${id}/download`;
    return this.http.get(newurl,
      {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        responseType: 'blob'
      }
    );
  }

  addFile(attachmentKey: string | number, file: string | any[]) {
    if (file.length < 1) {
      return;
    }
    if (this.newlyAttachedFiles[attachmentKey] === undefined)
      this.newlyAttachedFiles[attachmentKey] = [];
    this.newlyAttachedFiles[attachmentKey].push(file);
  }

  getAttachments() {

    return this.newlyAttachedFiles;
  }

  createFormData(attachmentKey: string | number) {
    const a = this.newlyAttachedFiles[attachmentKey];
    const fd = new FormData();
    if (a)
      for (let i = 0; i < a.length; i++) {
        if (!a[i].mime) {
          fd.append(this.formDataKey, a[i], a[i].fileType + '@#$' + a[i].name);
        }
      }
    return fd;
  }

  createFormDataSingle(attachmentKey: string | number, index: string | number) {
    const a = this.newlyAttachedFiles[attachmentKey];
    const fd = new FormData();
    if (a)
      if (!a[index].mime) {
        console.log(a[index].size);
        fd.append(this.formDataKey, a[index], a[index].fileType + '@#$' + a[index].name);
      }
    return fd;
  }

  uploadDocuments(url: string, attachmentKey: string | number, file?: string) {
    if (!_.isEmpty(file)) this.formDataKey = file;
    const formData = this.createFormData(attachmentKey);
    return new Promise((resolve, reject) => {
      if (formData.has(this.formDataKey)) {
        this.http.post(url, formData).subscribe((res) => {
          resolve(res);
          this.newlyAttachedFiles[attachmentKey] = undefined;
        }, (error) => {
          reject(error);
        });
      } else {
        reject('No files to upload');
      }
    });
  }

  uploadDocumentsSingle(url: string, attachmentKey: string | number, ind: string | number, file?: string) {
    if (!_.isEmpty(file)) this.formDataKey = file;
    const formData = this.createFormDataSingle(attachmentKey, ind);
    return new Promise((resolve, reject) => {
      if (formData.has(this.formDataKey)) {
        this.http.post(url, formData).subscribe((res) => {
          resolve(res);
          this.newlyAttachedFiles[attachmentKey] = undefined;
        }, (error) => {
          reject(error);
        });
      } else {
        reject('No files to upload');
      }
    });
  }

  uploadDocumentsContent(url: string, attachmentKey: string | number) {
    return new Promise((resolve, reject) => {
      if (this.newlyAttachedFiles[attachmentKey] === undefined || this.newlyAttachedFiles[attachmentKey].length === 0)
        reject('No files to upload.');
      const file = this.newlyAttachedFiles[attachmentKey][0];
      const fd = new FormData();
      fd.append('attachment-name', file.name);
      fd.append('attachment-type', file.fileType);
      fd.append('content', file);
      this.http.post(url, fd).subscribe((res) => {
        resolve(res);
        this.newlyAttachedFiles[attachmentKey] = undefined;
      }, (error) => {
        reject(error);
      });
    });
  }

  uploadDocumentsArray(url: string, files: any[]) {
    return new Promise((resolve, reject) => {
      if (files === undefined || files.length === 0)
        reject('No files to upload.');

      const fd = new FormData();
      files.forEach(file => {
        fd.append('documents', file);
      });

      this.http.post(url, fd).subscribe((res) => {
        resolve(res);
      }, (error) => {
        reject(error);
      });
    });
  }

  getDocumentsDetailsForRequestAndModule(url: string) {
    return this.http.get<unknown[]>(url);
  }


  deleteDocument(url: string) {
    return this.http.delete(url);
  }

  deleteNotUploadedDocs(attachmentKey: string | number, file?: { fileType: unknown; id: unknown; }) {
    if (file && this.newlyAttachedFiles[attachmentKey] && this.newlyAttachedFiles[attachmentKey].length > 0) {
      for (let i = 0; i < this.newlyAttachedFiles[attachmentKey].length; i++) {
        if (file.fileType === this.newlyAttachedFiles[attachmentKey][i].fileType ||
          (file.id && file.id === this.newlyAttachedFiles[attachmentKey][i].id)) {
          this.newlyAttachedFiles[attachmentKey].splice(i, 1);
        }
      }
    } else {
      delete this.newlyAttachedFiles[attachmentKey];
    }
  }

  downloadAttachmentDMS(id?: any): Observable<HttpResponse<Blob>> {
    const envValue: any = this.env.getEnvironment();
    const newurl = `${envValue.baseUrl}/${envValue.wso2amEndPoint}dms/api/v1/attachments/${id}/download`;
    return this.http.get(newurl, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
      responseType: 'blob',
      observe: 'response'
    });
  }
}
